import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { getIsGlifeContext } from "../selectors/settings-selectors";
import { getAppMode } from "../selectors/user-selectors";
import { AppMode } from "../http/protocol";
import { useGlifeOpenExternalLink } from "./useGlifeOpenExternalLink";

const disclaimerBlockedRoutes = ["/casino", "/sportsbook", "/poker", "/account", "/info", "/promo"];

const useGlifeDisclaimerRoute = () => {
  const history = useHistory();
  const isGlifeAppContext = useSelector(getIsGlifeContext);
  const isEmbeddedAppMode = useSelector(getAppMode) === AppMode.EMBEDDED;
  const { openExternalLink } = useGlifeOpenExternalLink();

  useEffect(() => {
    if (!isGlifeAppContext || !isEmbeddedAppMode) {
      return;
    }

    const unblock = history.block((tx) => {
      if (disclaimerBlockedRoutes.some((route) => tx.pathname.startsWith(route))) {
        openExternalLink(tx.pathname);
        return false; // Block the navigation
      }
    });

    return () => {
      unblock();
    };
  }, [history, isGlifeAppContext, isEmbeddedAppMode, openExternalLink]);
};

export default useGlifeDisclaimerRoute;
